export const newSearchFilters = {
  in_stock: false,
  distance: 100,
  dealer: [],
  model: [],
  vehicle_type: [],
  price: undefined,
  year: undefined,
  mileage: undefined,
  trimline: [],
  transmission: [],
  color_exterior: [],
  color_interior: [],
  sort_price: undefined,
  sort_added: undefined,
  sort_mileage:undefined
};

export const defaultFilters = {
  category: [],
  in_stock: false,
  distance: 100,
  dealer: [],
  model: [],
  vehicle_type: [],
  price: undefined,
  year: undefined,
  mileage: undefined,
  trimline: [],
  transmission: [],
  color_exterior: [],
  color_interior: [],
};
